export default __webpack_public_path__ + "static/media/Medal.5f0c16ec.webp";